export enum TargetingListTypeEnum {
    NORMAL = 'NORMAL',
    DISTRIBUTION_INDIVIDUAL_RECIPIENT = 'DISTRIBUTION_INDIVIDUAL_RECIPIENT',
    DISTRIBUTION_RECOMMENDED_RECIPIENT = 'DISTRIBUTION_RECOMMENDED_RECIPIENT'
}
